import TimeActivityCollection from '@spa/apps/trustup-pro-planning-js/collections/TimeActivityCollection';

export default class TrustUpIOTaskTimeActivityCollection extends TimeActivityCollection
{

    constructor(items, taskUuid)
    {
        super(items);

        this.taskUuid = taskUuid;
    }

    itemShouldBeInCollection(activity)
    {
        return activity.hasTrustUpIOTask(this.taskUuid);
    }

}